"use strict";

require("core-js/modules/es.array.flat-map.js");

require("core-js/modules/es.array.unscopables.flat-map.js");

var _toConsumableArray = require("/codebuild/output/src013157826/src/gardner/node_modules/@babel/runtime/helpers/toConsumableArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeHierarchicalDuplicates = exports.visitChildren = exports.removeChildMatching = exports.getReferencedBlocks = exports.getFlatBlockList = exports.isPublic = void 0;

var isPublic = function isPublic(page, publicMarkers) {
  return publicMarkers.includes(page.title) || extractChildren(page).some(function (it) {
    return matchesMarker(it, publicMarkers);
  });
};

exports.isPublic = isPublic;

function matchesMarker(block, markers) {
  var toRegex = function toRegex(marker) {
    return new RegExp("#?\\[\\[".concat(marker, "]]|#").concat(marker));
  };

  var markerRegexes = markers.map(toRegex);
  return markerRegexes.some(function (marker) {
    var _a;

    return (_a = block === null || block === void 0 ? void 0 : block.string) === null || _a === void 0 ? void 0 : _a.match(marker);
  });
}

var getFlatBlockList = function getFlatBlockList(pages) {
  return pages.flatMap(extractChildren);
};

exports.getFlatBlockList = getFlatBlockList;

var extractChildren = function extractChildren(block) {
  var _a;

  return ((_a = block.children) === null || _a === void 0 ? void 0 : _a.flatMap(function (it) {
    return [it].concat(_toConsumableArray(extractChildren(it)));
  })) || [];
};

function getReferencedBlocks(originPages, allPages) {
  var publicBlocks = exports.getFlatBlockList(originPages);
  var referencedBlockIds = new Set(publicBlocks.flatMap(function (it) {
    var _a;

    return ((_a = it.refs) === null || _a === void 0 ? void 0 : _a.map(function (ref) {
      return ref.uid;
    })) || [];
  }));
  return exports.getFlatBlockList(allPages).filter(function (it) {
    return referencedBlockIds.has(it.uid || "");
  });
}

exports.getReferencedBlocks = getReferencedBlocks;

var removeChildMatching = function removeChildMatching(page, privateMarkers) {
  var _a, _b;

  return Object.assign(Object.assign({}, page), {
    children: (_b = (_a = page === null || page === void 0 ? void 0 : page.children) === null || _a === void 0 ? void 0 : _a.filter(function (it) {
      return !matchesMarker(it, privateMarkers);
    })) === null || _b === void 0 ? void 0 : _b.map(function (it) {
      return exports.removeChildMatching(it, privateMarkers);
    })
  });
};

exports.removeChildMatching = removeChildMatching;

function visitChildren(block, visit) {
  var _a;

  visit(block);
  (_a = block === null || block === void 0 ? void 0 : block.children) === null || _a === void 0 ? void 0 : _a.forEach(function (it) {
    return visitChildren(it, visit);
  });
}

exports.visitChildren = visitChildren;

function removeHierarchicalDuplicates(blocks) {
  var nestedUids = new Set(exports.getFlatBlockList(blocks).map(function (it) {
    return it.uid;
  }));
  return blocks.filter(function (it) {
    return !nestedUids.has(it.uid);
  });
}

exports.removeHierarchicalDuplicates = removeHierarchicalDuplicates;